// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 13 JULY  2026 BOTTOM CARDS*/

/* =========================
   SECTION BACKGROUND
========================= */
.feature-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 40px;
  background: linear-gradient(90deg, #06a693 50%, #1ef3be 50%);
  position: relative;
}

/* =========================
   LEFT SIDE
========================= */
.feature-left {
  width: 50%;
  color: #fff;
  z-index: 2;
}

.feature-left h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.3;
}

.feature-left span {
  color: #e4e254;
}

.feature-left p {
  margin-top: 15px;
  font-size: 25px;
  max-width: 450px;
   color: #191908;
  
}

/* =========================
   RIGHT SIDE (CARD GRID)
========================= */
.feature-right {
  width: 45%;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

/* =========================
   CARD STYLE
========================= */
.feature-card {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #ddd;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  transition: 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.15);
}

/*  BOTTOM CARDS*/

/* MAIN CONTAINER */
.dashboard-container {

  display: flex;
  flex-direction: column;
  align-items: center;
background: linear-gradient(135deg, #058975, #38d6c9);
height: 80%;
box-shadow:
  0 4px 10px rgba(0,0,0,0.08),
  0 10px 25px rgba(0,0,0,0.12);
  padding: 2px;
}

/* HEADER */
.top-header {
  width: 100%;
  text-align: center;
  padding: 10px;
  animation: slideDown 0.6s ease;
}

.top-header h2 {
  font-size: 20px;
}

/* DASHBOARD PANEL */
.bottom-dashboard {
  width: 100%;
  margin-top: 10px;

  min-height: 140px;
  background: #fff;

  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;

  overflow-x: auto;
  border-radius: 12px;

  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  animation: fadeUp 0.7s ease;
}

/* CARD */
.dash-card {
  min-width: 110px;
  height: 120px;

  border-radius: 8px;
  background: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: all 0.3s ease;

  flex-shrink: 0;
}

/* IMAGE */


/* TEXT */
/* .dash-card h4 {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
} */
/* CARD TITLE */
.dash-card h4 {
  width: 100%;
  margin-top: 6px;
  padding: 4px 6px;

  font-size: 12px;
  font-weight: 600;
  text-align: center;

  background: linear-gradient(90deg, #0c907a, #16524f);
  color: #fff;

  border-radius: 4px;
}


/* HOVER */
.dash-card:hover {
  transform: translateY(-6px) scale(1.05);
  box-shadow: 0 10px 22px rgba(0,0,0,0.2);
}

/* ANIMATIONS */
@keyframes slideDown {
  from { transform: translateY(-40px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes fadeUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* SCROLLBAR */
.bottom-dashboard::-webkit-scrollbar {
  height: 5px;
}
.bottom-dashboard::-webkit-scrollbar-thumb {
  background: #074047;
  border-radius: 10px;
}
@media (max-width: 768px) {

  .top-header h2 {
    font-size: 16px;
  }

  .dash-card {
    min-width: 90px;
    height: 100px;
  }

  .dash-card img {
    width: 55%;
    height: 55%;
  }

  .dash-card h4 {
    font-size: 11px;
  }
}

@media (min-width: 1200px) {

  .dash-card {
    min-width: 150px;
    height: 150px;
  }

  .dash-card img {
    width: 70%;
    height: 70%;
  }

  .dash-card h4 {
    font-size: 14px;
  }
}



/* =========================
   PAGE CONTAINER
========================= */


.DBTools {
  padding: 20px;
  background: #f8fafc;
  min-height: 100vh;
  font-family: "Segoe UI", sans-serif;
}

/* =========================
   GRID LAYOUT
========================= */
.DBcards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  align-items: stretch;
}

/* =========================
          CARD
========================= */
.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);
}


/* =========================
   CARD HEADER
========================= */
.card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
}

.card-top .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

/* =========================
   MODULE LIST
========================= */
.module-list {
  height: 400px;              /* set your desired height */
  overflow-y: auto;           /* vertical scroll */
  padding-right: 6px;         /* avoid scrollbar overlap */
}
/* =========================
   MODULE ITEM
========================= */
.module {
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #f9fafb;
  border-radius: 10px;
  padding: 10px 12px;

  cursor: pointer;
  border: 1px solid #e5e7eb;

  transition: all 0.25s ease;
}

/* Hover Effect */
.module:hover {
  background: #eef6ff;
  transform: translateX(6px);
  border-color: #c7e0ff;
}

/* =========================
   MODULE LEFT
========================= */
.module-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* ICON */
.module-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  background: #e0f2fe;
  color: #0284c7;

  padding: 6px;
  border-radius: 8px;
}

/* TEXT */
.module-text h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.module-text span {
  font-size: 13px;
  color: #64748b;
}

/* ARROW */
.arrow {
  color: #94a3b8;
  transition: 0.2s;
}

.module:hover .arrow {
  transform: translateX(4px);
  color: #0284c7;
}

/* =========================
   ANIMATION (TOP → BOTTOM)
========================= */
.animate-module {
  opacity: 0;
  transform: translateY(-20px);
  animation: slideDown 0.5s ease forwards;
}

@keyframes slideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 768px) {
  .card {
    padding: 10px;
  }

  .module {
    padding: 8px;
  }

  .module-text h4 {
    font-size: 16px;
  }

  .module-text span {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/DBTools.css"],"names":[],"mappings":";AACA,8BAA8B;;AAE9B;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;;2BAE2B;AAC3B;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;GACf,cAAc;;AAEjB;;AAEA;;2BAE2B;AAC3B;EACE,UAAU;;EAEV,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,iBAAiB;;AAEjB,mBAAmB;AACnB;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB,qDAAqD;AACrD,WAAW;AACX;;8BAE8B;EAC5B,YAAY;AACd;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;;EAEhB,iBAAiB;EACjB,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;;EAEb,gBAAgB;EAChB,mBAAmB;;EAEnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;;EAEb,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,sCAAsC;EACtC,eAAe;EACf,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA,UAAU;;;AAGV,SAAS;AACT;;;;;GAKG;AACH,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,oDAAoD;EACpD,WAAW;;EAEX,kBAAkB;AACpB;;;AAGA,UAAU;AACV;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,cAAc;AACd;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;;;AAIA;;2BAE2B;;;AAG3B;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;;EAE1C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;;AAGA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa,eAAe,4BAA4B;EACxD,gBAAgB,YAAY,oBAAoB;EAChD,kBAAkB,UAAU,4BAA4B;AAC1D;AACA;;2BAE2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;;EAElB,eAAe;EACf,yBAAyB;;EAEzB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;EACnB,cAAc;;EAEd,YAAY;EACZ,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,UAAU;EACV,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;2BAE2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["\n/* 13 JULY  2026 BOTTOM CARDS*/\n\n/* =========================\n   SECTION BACKGROUND\n========================= */\n.feature-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 60px 40px;\n  background: linear-gradient(90deg, #06a693 50%, #1ef3be 50%);\n  position: relative;\n}\n\n/* =========================\n   LEFT SIDE\n========================= */\n.feature-left {\n  width: 50%;\n  color: #fff;\n  z-index: 2;\n}\n\n.feature-left h2 {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.feature-left span {\n  color: #e4e254;\n}\n\n.feature-left p {\n  margin-top: 15px;\n  font-size: 25px;\n  max-width: 450px;\n   color: #191908;\n  \n}\n\n/* =========================\n   RIGHT SIDE (CARD GRID)\n========================= */\n.feature-right {\n  width: 45%;\n\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n/* =========================\n   CARD STYLE\n========================= */\n.feature-card {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.05);\n  transition: 0.3s;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0,0,0,0.15);\n}\n\n/*  BOTTOM CARDS*/\n\n/* MAIN CONTAINER */\n.dashboard-container {\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\nbackground: linear-gradient(135deg, #058975, #38d6c9);\nheight: 80%;\nbox-shadow:\n  0 4px 10px rgba(0,0,0,0.08),\n  0 10px 25px rgba(0,0,0,0.12);\n  padding: 2px;\n}\n\n/* HEADER */\n.top-header {\n  width: 100%;\n  text-align: center;\n  padding: 10px;\n  animation: slideDown 0.6s ease;\n}\n\n.top-header h2 {\n  font-size: 20px;\n}\n\n/* DASHBOARD PANEL */\n.bottom-dashboard {\n  width: 100%;\n  margin-top: 10px;\n\n  min-height: 140px;\n  background: #fff;\n\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n\n  overflow-x: auto;\n  border-radius: 12px;\n\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n  animation: fadeUp 0.7s ease;\n}\n\n/* CARD */\n.dash-card {\n  min-width: 110px;\n  height: 120px;\n\n  border-radius: 8px;\n  background: #ffffff;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  flex-shrink: 0;\n}\n\n/* IMAGE */\n\n\n/* TEXT */\n/* .dash-card h4 {\n  margin-top: 5px;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n} */\n/* CARD TITLE */\n.dash-card h4 {\n  width: 100%;\n  margin-top: 6px;\n  padding: 4px 6px;\n\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n\n  background: linear-gradient(90deg, #0c907a, #16524f);\n  color: #fff;\n\n  border-radius: 4px;\n}\n\n\n/* HOVER */\n.dash-card:hover {\n  transform: translateY(-6px) scale(1.05);\n  box-shadow: 0 10px 22px rgba(0,0,0,0.2);\n}\n\n/* ANIMATIONS */\n@keyframes slideDown {\n  from { transform: translateY(-40px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n@keyframes fadeUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* SCROLLBAR */\n.bottom-dashboard::-webkit-scrollbar {\n  height: 5px;\n}\n.bottom-dashboard::-webkit-scrollbar-thumb {\n  background: #074047;\n  border-radius: 10px;\n}\n@media (max-width: 768px) {\n\n  .top-header h2 {\n    font-size: 16px;\n  }\n\n  .dash-card {\n    min-width: 90px;\n    height: 100px;\n  }\n\n  .dash-card img {\n    width: 55%;\n    height: 55%;\n  }\n\n  .dash-card h4 {\n    font-size: 11px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .dash-card {\n    min-width: 150px;\n    height: 150px;\n  }\n\n  .dash-card img {\n    width: 70%;\n    height: 70%;\n  }\n\n  .dash-card h4 {\n    font-size: 14px;\n  }\n}\n\n\n\n/* =========================\n   PAGE CONTAINER\n========================= */\n\n\n.DBTools {\n  padding: 20px;\n  background: #f8fafc;\n  min-height: 100vh;\n  font-family: \"Segoe UI\", sans-serif;\n}\n\n/* =========================\n   GRID LAYOUT\n========================= */\n.DBcards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 20px;\n  align-items: stretch;\n}\n\n/* =========================\n          CARD\n========================= */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);\n}\n\n\n/* =========================\n   CARD HEADER\n========================= */\n.card-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-radius: 12px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.card-top .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n}\n\n/* =========================\n   MODULE LIST\n========================= */\n.module-list {\n  height: 400px;              /* set your desired height */\n  overflow-y: auto;           /* vertical scroll */\n  padding-right: 6px;         /* avoid scrollbar overlap */\n}\n/* =========================\n   MODULE ITEM\n========================= */\n.module {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  background: #f9fafb;\n  border-radius: 10px;\n  padding: 10px 12px;\n\n  cursor: pointer;\n  border: 1px solid #e5e7eb;\n\n  transition: all 0.25s ease;\n}\n\n/* Hover Effect */\n.module:hover {\n  background: #eef6ff;\n  transform: translateX(6px);\n  border-color: #c7e0ff;\n}\n\n/* =========================\n   MODULE LEFT\n========================= */\n.module-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* ICON */\n.module-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #e0f2fe;\n  color: #0284c7;\n\n  padding: 6px;\n  border-radius: 8px;\n}\n\n/* TEXT */\n.module-text h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.module-text span {\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* ARROW */\n.arrow {\n  color: #94a3b8;\n  transition: 0.2s;\n}\n\n.module:hover .arrow {\n  transform: translateX(4px);\n  color: #0284c7;\n}\n\n/* =========================\n   ANIMATION (TOP → BOTTOM)\n========================= */\n.animate-module {\n  opacity: 0;\n  transform: translateY(-20px);\n  animation: slideDown 0.5s ease forwards;\n}\n\n@keyframes slideDown {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* =========================\n   RESPONSIVE\n========================= */\n@media (max-width: 768px) {\n  .card {\n    padding: 10px;\n  }\n\n  .module {\n    padding: 8px;\n  }\n\n  .module-text h4 {\n    font-size: 16px;\n  }\n\n  .module-text span {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
